export const FIND_SERVICE_HISTORY_MODAL = 'findServiceHistory'
export const FIND_SERVICE_HISTORY_PAGE_SRC = '/modals/find-service-history'

export const VEHICLE_AND_DATA_MISMATCH_CODE = '1027'
export const VEHICLE_AND_DATA_MISMATCH_FLAG = 'VEHICLE_AND_DATA_MISMATCH'
